window.app = window.app || {};

window.app.orderTracking = {
  el: {
    form: document.querySelector('.mt-order-tracking__form'),
    trackingNumber: document.querySelector('.mt-ot-form input[name="trackingNumber"]'),
    courierInfo: document.querySelector('.mt-ot-form__courier-info'),
    couriers: document.querySelector('.mt-ot-form__couriers')
  },

  courier: {
    ups: 'https://www.ups.com/track?tracknum=#TRACKING_NUMBER#',
    usps_osm: 'https://www.osmworldwide.com/tracking/?trackingNumbers=#TRACKING_NUMBER#',
    fedex: 'https://www.fedex.com/fedextrack/?trknbr=#TRACKING_NUMBER#',
    postnl: 'https://www.postnl.nl/ontvangen/post-ontvangen/track-en-trace/?tt=#TRACKING_NUMBER#'
  },

  getCourierByTrackingID: function(trackingNumber = null) {
    let courier = null;

    (/^1Z/.test(trackingNumber)) && (courier = 'ups');
    (/^[0-9]{20,22}$/.test(trackingNumber)) && (courier = 'usps_osm');
    (/^[0-9]{12}$/.test(trackingNumber)) && (courier = 'fedex');
    (/^[A-Z]{2}\d{9}NL$/.test(trackingNumber)) && (courier = 'postnl');

    return courier;
  },

  getTrackingURL: function(trackingNumber = null, courier = 'auto') {
    const _this = this;
    if (trackingNumber === null) return 0;

    const courierName = (courier === 'auto') ? _this.getCourierByTrackingID(trackingNumber) : courier;
    let trackingURL;

    if (_this.courier[courierName]) {
      const courierInput = _this.el.couriers.querySelector(`input[value='${courierName}']`);
      courierInput && (courierInput.checked = true);
      trackingURL = _this.courier[courierName].replace('#TRACKING_NUMBER#', trackingNumber);

      return trackingURL;
    }
  },

  init: function() {
    const _this = this;

    if (!_this.el.form) return;
    _this.el.trackingNumber.addEventListener('input', () => {
      const courierName = _this.getCourierByTrackingID(_this.el.trackingNumber.value.replace(/ /g,'')) ? _this.getCourierByTrackingID(_this.el.trackingNumber.value.replace(/ /g,'')) : 'auto';
      const courierInput = _this.el.couriers.querySelector(`input[value='${courierName}']`);
      courierInput && (courierInput.checked = true);
      if (courierName !== 'auto' || _this.el.trackingNumber.value === '') {
        _this.el.couriers.classList.add('hidden');
        _this.el.courierInfo.classList.add('hidden');
      } else {
        _this.el.couriers.classList.remove('hidden');
        _this.el.courierInfo.classList.remove('hidden');
      }
    });
    _this.el.form.addEventListener('submit', e => {
      e.preventDefault();
      e.stopPropagation();

      const courier = _this.el.form.querySelector('[name="courier"]:checked');
      const trackingNumber = _this.el.form.querySelector('[name="trackingNumber"]');
      const trackingUrl = _this.getTrackingURL(trackingNumber.value.replace(/ /g,''), courier.value);

      if (trackingUrl) {
        window.open(trackingUrl, '_blank').focus();
      } else {
        _this.el.courierInfo.classList.remove('hidden');
      }
    });
  }
}
window.app.orderTracking.init();